<template>
  <custom-dialog :title="model.title" :appendToBody="true" :visible="visible" width="400px" v-on="$listeners" class="update-pay-info-field-dialog">
    <div class="dialog-body" style="padding-top: 0 !important; padding-bottom: 24px !important">
      <el-form label-position="top" :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
        <el-form-item v-if="auth.includes('buyerAccount')" :label="$t('update_pay_info_filed_dialog.fkfzh')" prop="buyerAccount">
          <custom-select
            v-if="dicCodeName.bank_branch"
            v-model="form.buyerAccount"
            url="PartnerBankcardListByOrgId"
            :params="{ orgId: payableOrgId }"
            :props="{ label: 'label', value: 'depositNumber' }"
            @getList="onBuyerAccountGetList"
            :dataFilter="bankListFilter"
            ref="bank"
          ></custom-select>
        </el-form-item>

        <el-form-item v-if="auth.includes('sellerAccount')" :label="$t('update_pay_info_filed_dialog.shou_kuan_zhang_hu')" prop="sellerAccount">
          <custom-select
            v-if="dicCodeName.bank_branch"
            v-model="form.sellerAccount"
            url="PartnerBankcardListByOrgId"
            :params="{ orgId: receivableOrgId }"
            :props="{ label: 'label', value: 'depositNumber' }"
            @getList="onSellerAccountGetList"
            :dataFilter="bankListFilter"
          ></custom-select>
        </el-form-item>

        <el-form-item v-if="auth.includes('totalAmount')" :label="$t('update_pay_info_filed_dialog.fu_kuan_jin_e')" prop="totalAmount">
          <el-input v-model="form.totalAmount" type="number"></el-input>
        </el-form-item>

        <el-form-item v-if="auth.includes('tradeFinishTime')" :label="$t('update_pay_info_filed_dialog.fu_kuan_ri_qi')" prop="tradeFinishTime">
          <custom-date-picker v-model="form.tradeFinishTime" :picker-options="beforeToday" type="date" style="width: 100%" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
      </el-form>
      <el-button class="btn-confirm" type="warning" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  name: 'updatePayInfoFiledDialog',
  props: {
    auth: {
      type: Array,
      default() {
        return ['buyerAccount', 'sellerAccount', 'totalAmount', 'tradeFinishTime'];
      },
    },
    payableOrgId: String,
    receivableOrgId: String,
  },
  data() {
    return {
      form: {
        // 付款方账户
        buyerAccount: '',
        // 收款方账户
        sellerAccount: '',
        // 付款日期
        tradeFinishTime: '',
        // 付款金额
        totalAmount: '',
      },
      sellerAccountList: [],
      buyerAccountList: [],
      transactionReceipt: [],
    };
  },
  computed: {
    rules() {
      return {
        buyerAccount: [{ required: true, message: this.$t('Common.com_required') }, { max: 20 }],
        sellerAccount: [{ required: true, message: this.$t('Common.com_required') }, { max: 20 }],
        totalAmount: { required: true, message: this.$t('Common.com_required') },
        tradeFinishTime: { required: true, message: this.$t('Common.com_required') },
      };
    },
  },
  mounted() {
    this.getDictionaryCodeName('bank_branch', () => {
      this.init();
    });
  },
  methods: {
    init() {
      const form = this.model.data;
      this.$setFormatData(this.form, form);
    },
    onBuyerAccountGetList(list) {
      this.buyerAccountList = list;
      if (this.form.buyerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.buyerAccount = item.depositNumber;
      }
    },
    // 格式化银行列表数据，使label为：账号/银行/支行
    bankListFilter(list) {
      list.forEach((item) => {
        const depositBank = item.depositBank;
        const depositNumber = item.depositNumber;
        item.label = [depositNumber, depositBank].join('/');
      });
      return list;
    },
    onSellerAccountGetList(list) {
      this.sellerAccountList = list;
      if (this.form.sellerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.sellerAccount = item.depositNumber;
      }
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const emitData = this.getEmitData();
          this.$emit('confirm', emitData);
          this.visible = false;
        }
      });
    },
    getEmitData() {
      const ret = {};
      this.auth.forEach((key) => {
        ret[key] = this.form[key];
      });
      return ret;
    },
  },
};
</script>

<style lang="scss">
.update-pay-info-field-dialog {
  .el-dialog .el-dialog__body .el-form-item__label {
    padding-bottom: 0;
  }

  .btn-confirm {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
